import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { NhanVienResponse } from "../models/nhanvien/NhanVien";
import { ChucNangQuyenRequest, PhanQuyenRequest, QuyenRequest, QuyenResponse } from "../models/quyen/Quyen";
import intance from "../utils/axios";

export const layDSTatCaQuyen = async () => {
    var rs: Array<QuyenResponse> = [];
    await intance.get(ApiPaths.quyen.layToanBo)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = (res.data.duLieu)
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const luuChucNangTheoQuyen = async (request: ChucNangQuyenRequest) => {
    let rs = false;
    await intance.post(ApiPaths.quyen.luuChucNangQuyen, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}

export const luuQuyen = async (request: QuyenRequest) => {
    let rs = false;
    await intance.post(ApiPaths.quyen.luuQuyen, request)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

export const xoaQuyen = async (idQuyen: number) => { 
    let rs = false;
    await intance.post(ApiPaths.quyen.xoaQuyen + `?id=${idQuyen}`)
        .then(res => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true
            }
        })
        .catch(err => {
            throw err;
        })
    return rs;
}

export const layDSQuyenTheoIdNguoiDung = async (idNguoiDung: number) => {
    var data: Array<QuyenResponse> = [];
    await intance.get(ApiPaths.quyen.layDsQuyenTheoIdNguoiDung + `?idNguoiDung=${idNguoiDung}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
        })
        .catch((error) => {
            throw error
        })
    return data;
}

export const luuQuyenTheoIdNguoiDung = async (request: PhanQuyenRequest) => {
    var rs = false;
    await intance.post(ApiPaths.quyen.luuQuyenTheoIdNguoiDung, request)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error
        })
    return rs;
}

export const layDSNhanVienCoQuyenBCHCongDoan = async () => {
    var data: Array<NhanVienResponse> = [];
    await intance.get(`${ApiPaths.quyen.layDSNhanVienTheoIdQuyen}?idQuyen=11`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};